<template>
  <div>
    <DevNotes>
      Communication Center : 40%
      <div>Progression : Dev 40% / Test 0%</div>
      Development Notes
      - รับ Notification จากระบบแชท
    </DevNotes>

    <component :is="getCurrentStage().k" /> 

  </div>
</template>

<script>
import { getCurrentStage } from "@/developing/dev-data";
import { bulkImportComponent } from "@/developing/utils/modular";

export default {
  components: {
    DevNotes: () => import("@/developing/dev-components/DevNotes"),
    ...bulkImportComponent("components/communication")
  },
  methods: {
    getCurrentStage
  }
  // beforeCreate() {
  //   if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  // },
  // destroyed() {
  //   this.$store.unregisterModule(StoreModuleName);
  // },
}
</script>
